import React from 'react';
import PropTypes from 'prop-types';

const MarkdownLink = ({ node, children, ...props }) => (
  <a
    {...props}
    target="_blank"
    rel="noopener noreferrer"
    style={{ color: 'blue', textDecoration: 'underline' }}
  >
    {children}
  </a>
);

MarkdownLink.propTypes = {
  node: PropTypes.any,
  children: PropTypes.node,
};

export const MARKDOWN_COMPONENTS = { a: MarkdownLink };
